import React from 'react';
import { Component } from 'react';
import carData from '../../data/carSelectionData';
import Constants from '../../data/constants';
import DriversLicenseFront from '../../static/img/ID_Front.png';
import DriversLicenseBack from '../../static/img/ID_Back.png';
import Call from '../../utils/Call';
import { linkPlaceholder } from '../../utils/TranslationUtils';

class DriversLicenseBlock extends Component {
    constructor(props) {
        super(props);

        this.state = {
            checkboxAttr: "disabled",
            acceptBtnAttr: "disabled",
            dlFront: "url(" + `${Constants().RESOURCE_BASE_URL}${DriversLicenseFront}` + ")",
            dlBack: "url(" + `${Constants().RESOURCE_BASE_URL}${DriversLicenseBack}` + ")",
            dlFrontClass: "",
            dlBackClass: ""
        }

        this.dlFrontFile = false;
        this.dlBackFile = false;
        this.call = new Call();
    }

    onFileChange(elem, e) {
        let _that = this;
        _that.setState({
            [elem + "Class"]: ""
        });

        let reader = new FileReader();
        reader.onload = function() {
            _that.setState({
                [elem]: "url(" + `${reader.result}` + ")"
            });
        };

        reader.readAsDataURL(e.target.files[0]);
        this.call.uploadFile(elem, e.target.files[0])
            .then( data => {
                if (data.success) {
                    this[elem + "File"] = true;
                    this.props.updateValue(elem, data.file);
                    this.checkValidation();
                }
                else {
                    _that.setState({
                        [elem + "Class"]: "show"
                    });
                }
            })
    }

    checkValidation() {
        this.props.store.dispatch({
            type: Constants().ENABLE_ACCEPT_TERMS,
            buttonStatus: ((this.dlFrontFile && this.dlBackFile && this.termsCheckbox.checked) ? "" : "disabled")
        })
    }

    handleFileupload(elem, event) {
        event.preventDefault();
        this[elem].click();
    }

    componentDidMount() {
        this.terms.addEventListener("scroll", this.checkScrollHeight.bind(this), false);
    }

    checkScrollHeight() {
        let { offsetHeight, scrollTop, scrollHeight } = this.terms;
        if ((offsetHeight + scrollTop) >= scrollHeight ) {
            this.setState({
                checkboxAttr: ""
            });
        }
    }

    handleCheckbox(e) {
        this.checkValidation();
    }

    acceptTerms() {
        this.props.handleSubmit();
    }

    render() {
        const driverlicenseSection = (typeof window.tesla !== "undefined") ? window.tesla.App.strings['Test_Drive/All'].content.driverlicenseSection : {};
        const showBulletPoints = (typeof driverlicenseSection.reviewPoints !== "undefined");

        let locale = "";
        if (typeof window.tesla !== "undefined") {
            if (locale != "en_US") {
                locale = window.tesla.App.locale;
            }

        }

        return (
            <div>
                <div className="driver-license-upload">
                    <section className="dl-container">
                        <div className="dl-img" style={{backgroundImage: this.state.dlFront}}>
                            <span className={this.state.dlFrontClass}>Invalid file type</span>
                        </div>
                        <div className="dl-txt">
                            <h4>
                                {driverlicenseSection.dlFront}
                                <input type="file"
                                    onChange={this.onFileChange.bind(this, "dlFront")}
                                    ref={ (input) => { this.dlFront = input; } }
                                    className="file-upload"
                                    accept="image/png, image/jpeg, image/jpg" />
                                <a href="#" className="add-file tds-link--primary" onClick={this.handleFileupload.bind(this, "dlFront")}>{driverlicenseSection.addLink}</a>
                            </h4>
                            <span>{driverlicenseSection.imgTxt}</span>
                        </div>
                    </section>
                </div>
                <div className="driver-license-upload">
                    <section className="dl-container">
                        <div className="dl-img" style={{backgroundImage: this.state.dlBack}}>
                            <span className={this.state.dlBackClass}>Invalid file type</span>
                        </div>
                        <div className="dl-txt">
                            <h4>
                                {driverlicenseSection.dlBack}
                                <input type="file"
                                    onChange={this.onFileChange.bind(this, "dlBack")}
                                    ref={ (input) => { this.dlBack = input; } }
                                    className="file-upload"
                                    accept="image/png, image/jpeg, image/jpg" />
                                <a href="#" className="add-file tds-link--primary" onClick={this.handleFileupload.bind(this, "dlBack")}>{driverlicenseSection.addLink}</a>
                            </h4>
                            <span>{driverlicenseSection.imgTxt}</span>
                        </div>
                    </section>
                </div>
                <div className="driver-license-terms">
                    <h4>{driverlicenseSection.reviewTxt}</h4>
                    <section className="driver-license-terms-txt" ref={ input => { this.terms = input; } }>
                        <h4>{driverlicenseSection.reviewTitle}</h4>
                        <p>{driverlicenseSection.reviewUnderTxt}</p>
                        <p className="bold">{driverlicenseSection.reviewTerms}</p>
                        <ol>
                            {showBulletPoints ?
                                driverlicenseSection.reviewPoints.map((value, index) => {
                                    return <li key={index}>{value}</li>
                                })
                            : null}
                        </ol>
                        <p className="bold">{driverlicenseSection.privacy}</p>
                        <p>{driverlicenseSection.confirmEligibility}</p>
                        <table className="terms-table" cellSpacing="0">
                            <thead>
                                <tr>
                                    <th>{driverlicenseSection.tableTitleOne}</th>
                                    <th>{driverlicenseSection.tableTitleTwo}</th>
                                    <th>{driverlicenseSection.tableTitleThree}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{driverlicenseSection.tableOneOne}</td>
                                    <td>{driverlicenseSection.tableOneTwo}</td>
                                    <td>{driverlicenseSection.tableOneThree}</td>
                                </tr>
                                <tr>
                                    <td>{driverlicenseSection.tableTwoOne}</td>
                                    <td>{driverlicenseSection.tableTwoTwo}</td>
                                    <td>{driverlicenseSection.tableTwoThree}</td>
                                </tr>
                                <tr>
                                    <td>{driverlicenseSection.tableThreeOne}</td>
                                    <td>{driverlicenseSection.tableThreeTwo}</td>
                                    <td>{driverlicenseSection.tableThreeThree}</td>
                                </tr>
                            </tbody>
                        </table>
                        <p>
                            <span dangerouslySetInnerHTML={{__html: linkPlaceholder(
                                    driverlicenseSection.privacyNotice,
                                    { LINK: driverlicenseSection.privacyNoticeLbl },
                                    '/' + locale + '/about/legal'
                                )}} >
                            </span>
                        </p>
                        <p className="last-sentence">{driverlicenseSection.byContinuing}</p>
                    </section>
                    <div className="tds-form-item">   
                        <fieldset className="tds-form-fieldset">     
                            <div className="tds-checkboxes">       
                                <div className="tds-checkbox">         
                                    <input
                                        className="tds-checkbox-input"
                                        type="checkbox"
                                        id="terms-accept"
                                        disabled={this.state.checkboxAttr}
                                        onClick={this.handleCheckbox.bind(this)}
                                        ref={ input => { this.termsCheckbox = input; } } />
                                    <label className="tds-label tds-label--checkbox" htmlFor="terms-accept">           
                                        <span className="tds-label-title">{driverlicenseSection.reviewAccept}</span>
                                    </label>       
                                </div>
                            </div>
                        </fieldset>
                    </div>
                </div>
            </div>
        )
    }
}

export default DriversLicenseBlock
